import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Container, Form, Button, Row, Col } from "react-bootstrap";

const Tally = () => {
  const backendURI = process.env.REACT_APP_BK_URL;
  const navigate = useNavigate();

  const [conditions, setConditions] = useState({
    username: JSON.parse(localStorage.getItem("username")),
    shopname: JSON.parse(localStorage.getItem("address")),
    id: JSON.parse(localStorage.getItem("id")),
    home_delivery: false,
    err: undefined,
    tallyAmount: 0,
    totalPaid: 0,
    startDate: "",
    endDate: "",
  });

  const [data, setData] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams();

    if (conditions.startDate) {
      params.append("strt", conditions.startDate);
    }

    if (conditions.endDate) {
      params.append("end", conditions.endDate);
    }

    const url = `${backendURI}/api/tally/${conditions.id}/${conditions.home_delivery}${params.toString() ? `?${params.toString()}` : ""
      }`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch tally data");
        }
        return response.json();
      })
      .then((json) => {
        const orders = Array.isArray(json) ? json : [];
        setData(orders);
        setConditions((prev) => ({
          ...prev,
          err: undefined,
        }));
      })
      .catch((err) => {
        console.error("Failed to fetch tally data:", err);
        setData([]);
        setConditions((prev) => ({
          ...prev,
          err: "Failed to fetch tally data",
        }));
      });
  }, [
    backendURI,
    conditions.id,
    conditions.home_delivery,
    conditions.startDate,
    conditions.endDate,
  ]);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) {
      setConditions((prev) => ({
        ...prev,
        tallyAmount: 0,
        totalPaid: 0,
      }));
      return;
    }

    const tallyAmount = data.reduce((sum, item) => {
      return sum + (parseInt(item.total, 10) || 0);
    }, 0);

    const totalPaid = data.reduce((sum, item) => {
      return item.paid === true
        ? sum + (parseInt(item.total, 10) || 0)
        : sum;
    }, 0);

    setConditions((prev) => ({
      ...prev,
      tallyAmount,
      totalPaid,
    }));
  }, [data]);

  return (
    <div>
      <Container>
        <h2 className="text-center text-warning text-decoration-underline">
          Tally
        </h2>

        <br />

        <p className="text-center">
          Please select the dates in boxes below to get the tally between the
          dates. By default tally of all matching orders.
        </p>

        <br />

        <Form>
          <Form.Group className="mb-3" controlId="formTallyStartDate">
            <Form.Label>Tally Start Date</Form.Label>
            <Form.Control
              type="date"
              value={conditions.startDate}
              onChange={(e) => {
                setConditions((prev) => ({
                  ...prev,
                  startDate: e.target.value,
                  err: undefined,
                }));
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formTallyEndDate">
            <Form.Label>Tally End Date</Form.Label>
            <Form.Control
              type="date"
              value={conditions.endDate}
              onChange={(e) => {
                setConditions((prev) => ({
                  ...prev,
                  endDate: e.target.value,
                  err: undefined,
                }));
              }}
            />
          </Form.Group>
        </Form>

        <br />

        <div className="mx-3 my-3 text-danger font-weight-bold">
          <Row>
            <Col className="text-center">
              Tally Start Date Selected :
              <span className="text-decoration-underline">
                {conditions.startDate || " Not selected"}
              </span>
            </Col>
            <Col className="text-center">
              Tally End Date Selected :
              <span className="text-decoration-underline">
                {conditions.endDate || " Not selected"}
              </span>
            </Col>
          </Row>
        </div>

        <br />

        {conditions.err !== undefined ? (
          <h3>{conditions.err}</h3>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th className="text-center">Admin Name</th>
                <th className="text-center">Shop Name</th>
                <th className="text-center">Total Tally for this period</th>
                <th className="text-center">
                  Total amount paid in this period
                </th>
                <th className="text-center">Total amount receivable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">{conditions.username}</td>
                <td className="text-center">{conditions.shopname}</td>
                <td className="text-center">₹ {conditions.tallyAmount}/-</td>
                <td className="text-center">₹ {conditions.totalPaid}/-</td>
                <td className="text-center">
                  ₹ {conditions.tallyAmount - conditions.totalPaid}/-
                </td>
              </tr>
            </tbody>
          </Table>
        )}
      </Container>

      <br />
      <br />

      <Button className="mx-3 my-5" onClick={() => navigate("/admindash")}>
        &#8592; Go to dashboard.
      </Button>
    </div>
  );
};

export default Tally;
